import React, { Component, useEffect, useState } from 'react'
import CustomTitle from '../../../components/UI/title/CustomTitle'
import { useDispatch, useSelector } from 'react-redux';
import useMixpanel from '../../../hooks/useMixpanel';
import { setButtonBackClick, setButtonBackIsShow, setButtonClick } from '../../../store/buttonSlice';
import axios from 'axios';

export default function ResetPassword({ code, setPageComponent, handlePassword2Change, inputPassword2, setError, logIn, showPassword, inputPassword, handlePasswordChange, setShowPassword, setButtonStatus, inputEmail, setButtonText, setInputPassword, setInputPassword2 }) {


    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const dispatch = useDispatch();

    const [errorPsw1, setErrorPsw1] = useState(false);
    const [msgPsw1, setMsgPsw1] = useState('');
    const [errorPsw2, setErrorPsw2] = useState(false);
    const [msgPsw2, setMsgPsw2] = useState('');
    const { trackP1Event } = useMixpanel();

    useEffect(() => {
        setButtonText("Let’s start!");
        trackP1Event('web_forgot_password_view', {})
        dispatch(setButtonBackIsShow(true));
        setInputPassword('');
        setInputPassword2('');
        setError(false)
    }, [])

    const [noPassword, setNoPassword] = useState(false);
    const [wrongFormat, setWrongFormat] = useState(false);
    const [noConfirm, setNoConfirm] = useState(false);
    const [noMatch, setNoMatch] = useState(false);

    useEffect(() => {
        if (buttonClicked) {

            const minLength = 8;
            if (inputPassword.trim() === '' && inputPassword2.trim() === '') {

                setButtonStatus("NewPassword");
                setErrorPsw1(true);
                setErrorPsw2(true);
                setError(true)
                setMsgPsw2('Please, enter your password')
                setNoPassword(true);
                // setTimeout(() => {
                //     setError(false);
                //     setErrorPsw1(false);
                //     setErrorPsw2(false);
                // }, 1000);
                setTimeout(() => {
                    dispatch(setButtonClick(false));
                }, 100);
                return;
            }

            if (inputPassword.trim().length < minLength) {
                setError(true);
                setErrorPsw1(true);
                setMsgPsw1(`Your password should be at least ${minLength} characters`);
                setWrongFormat(true);
                // setTimeout(() => {
                //     setError(false);
                //     setErrorPsw1(false);
                // }, 1000);
                setTimeout(() => {
                    dispatch(setButtonClick(false));
                }, 100);
                return;
            }


            if (inputPassword.trim() !== inputPassword2.trim()) {
                setError(true);
                setErrorPsw2(true);
                setMsgPsw2('Oops! These passwords aren’t the same')
                setNoMatch(true);
                // setTimeout(() => {
                //     setError(false);
                //     setErrorPsw2(false);
                // }, 1000);
            } else {

                setButtonStatus('load');
                changePassword(code.join(''))
            }
            setTimeout(() => {
                dispatch(setButtonClick(false));
            }, 100);
        }

    }, [buttonClicked, inputPassword, inputPassword2]);

    const changePassword = (passwordCode,) => {
        const data = {
            email: inputEmail,
            "code": passwordCode,
            "newPassword": inputPassword,
        };

        axios.post("https://staging.zeely.link/users/change-password-by-code", data, {
            headers: {
                "Content-Type": "application/json"
            },
            redirect: 'follow'
        })
            .then(response => {
                trackP1Event('web_forgot_password_done', {
                    web_entrance: 'login',
                    confirm_success: "TRUE",
                    signin_success: "TRUE",
                    error_reason: [
                        noPassword && "no_password",
                        wrongFormat && "wrong_format",
                        noMatch && "no_match"
                    ].filter(Boolean).join(",") || "none"
                })
                logIn(true, noPassword, wrongFormat, noMatch);
            })
            .catch(error => {

                trackP1Event('web_forgot_password_done', {
                    web_entrance: 'login',
                    confirm_success: "TRUE",
                    signin_success: "FALSE",
                    error_reason: [
                        noPassword && "no_password",
                        wrongFormat && "wrong_format",
                        noMatch && "no_match",
                        "no_confirm"
                    ].filter(Boolean).join(",") || "none"
                })
                setNoConfirm(true);

                setButtonStatus("");
            });
    };


    const buttonBackClicked = useSelector((state) => state.button.buttonBackClicked);
    useEffect(() => {
        if (buttonBackClicked) {
            setTimeout(() => {
                dispatch(setButtonBackClick(false));
                setPageComponent('enterCode');
            }, 100);
        }
    }, [buttonBackClicked]);

    return (
        <div style={{ paddingBottom: '36rem' }}>
            <CustomTitle style={{ marginBottom: "24rem" }} title={'Create new password'} />
            <p className="text" style={{ marginTop: "-12rem", marginBottom: '24rem' }}>
                Ensure your new password is secure and
                at least 8 characters long.
            </p>


            <div className={`input ${errorPsw1 ? 'error' : ''}`} style={{ marginTop: "10rem" }}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0003 1.92773C12.3672 1.92773 14.286 3.84651 14.286 6.21345L14.2875 7.65826C14.8895 7.69557 15.2735 7.80091 15.6695 8.01265C16.1432 8.26598 16.5192 8.642 16.7725 9.11569C17.0477 9.63017 17.1431 10.1246 17.1431 11.1033V15.6093C17.1431 16.588 17.0477 17.0824 16.7725 17.5969C16.5192 18.0706 16.1432 18.4466 15.6695 18.7C15.155 18.9751 14.6605 19.0706 13.6818 19.0706H6.31873C5.34002 19.0706 4.84558 18.9751 4.33109 18.7C3.8574 18.4466 3.48138 18.0706 3.22805 17.5969C2.9529 17.0824 2.85742 16.588 2.85742 15.6093V11.1033C2.85742 10.1246 2.9529 9.63017 3.22805 9.11569C3.48138 8.642 3.8574 8.26598 4.33109 8.01265C4.72717 7.80082 5.11138 7.69548 5.71381 7.65822L5.71456 6.21345C5.71456 3.84651 7.63334 1.92773 10.0003 1.92773ZM13.6818 9.07059H6.31873C5.55568 9.07059 5.28404 9.12305 5.0048 9.27239C4.78007 9.39257 4.60797 9.56467 4.48779 9.7894C4.33845 10.0686 4.28599 10.3403 4.28599 11.1033V15.6093C4.28599 16.3723 4.33845 16.644 4.48779 16.9232C4.60797 17.1479 4.78007 17.32 5.0048 17.4402C5.28404 17.5896 5.55568 17.642 6.31873 17.642H13.6818C14.4449 17.642 14.7165 17.5896 14.9958 17.4402C15.2205 17.32 15.3926 17.1479 15.5128 16.9232C15.6621 16.644 15.7146 16.3723 15.7146 15.6093V11.1033C15.7146 10.3403 15.6621 10.0686 15.5128 9.7894C15.3926 9.56467 15.2205 9.39257 14.9958 9.27239C14.7165 9.12305 14.4449 9.07059 13.6818 9.07059ZM10.0003 11.2134C10.3948 11.2134 10.7146 11.5332 10.7146 11.9277V14.0706C10.7146 14.4651 10.3948 14.7849 10.0003 14.7849C9.60579 14.7849 9.28599 14.4651 9.28599 14.0706V11.9277C9.28599 11.5332 9.60579 11.2134 10.0003 11.2134ZM10.0003 3.35631C8.42232 3.35631 7.14314 4.63549 7.14314 6.21345V7.64202H12.8574V6.21345C12.8574 4.63549 11.5782 3.35631 10.0003 3.35631Z" fill="#CAD4DD" />
                </svg>
                <input type={showPassword ? 'text' : 'password'}
                    value={inputPassword}
                    onChange={(e) => { handlePasswordChange(e); setError(false); setErrorPsw1(false); setErrorPsw2(false); }} placeholder={'Create new password'}
                    style={{ paddingLeft: "46rem", paddingRight: "46rem" }}


                    onFocus={() => trackP1Event('web_forgot_password_input', {})}
                    onBlur={() => trackP1Event('web_forgot_password_success', {})}
                />
                <div className="show" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.05517 4.26529L10.2391 8.44922L10.2417 8.44856L14.0505 12.2573L14.0498 12.2599L18.6266 16.8367C18.9334 17.1436 18.9334 17.641 18.6266 17.9479C18.3198 18.2547 17.8223 18.2547 17.5154 17.9479L16.042 16.4758C14.5201 17.3133 12.7915 17.7852 10.9996 17.7852C6.42811 17.7852 1.96387 14.3626 1.96387 11.4994C1.96387 9.82823 3.68082 7.7521 6.04421 6.47673L4.944 5.37645C4.63716 5.06961 4.63716 4.57213 4.944 4.26529C5.25084 3.95845 5.74832 3.95845 6.05517 4.26529ZM3.5353 11.4994C3.5353 13.3899 7.21857 16.2137 10.9996 16.2137C12.3608 16.2137 13.683 15.8912 14.8763 15.3105L13.2554 13.6878C12.6842 14.2765 11.8846 14.6423 10.9996 14.6423C9.26383 14.6423 7.85672 13.2352 7.85672 11.4994C7.85672 10.6144 8.22254 9.81484 8.8112 9.24366L7.21234 7.64607C5.09127 8.65283 3.5353 10.4261 3.5353 11.4994ZM10.9996 5.21373C15.5711 5.21373 20.0353 8.63631 20.0353 11.4994C20.0353 12.2417 19.6949 13.0695 19.0951 13.8828C18.8375 14.232 18.3456 14.3063 17.9964 14.0488C17.6471 13.7912 17.5728 13.2993 17.8304 12.9501C18.248 12.3839 18.4639 11.8588 18.4639 11.4994C18.4639 9.609 14.7806 6.78516 10.9996 6.78516C10.5656 6.78516 10.2139 6.43338 10.2139 5.99944C10.2139 5.5655 10.5656 5.21373 10.9996 5.21373ZM9.92262 10.3551C9.61821 10.6417 9.42815 11.0484 9.42815 11.4994C9.42815 12.3673 10.1317 13.0709 10.9996 13.0709C11.4507 13.0709 11.8574 12.8808 12.1439 12.5764L9.92262 10.3551Z" fill="black" />
                        </svg>

                    ) : (
                        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.9996 5.21484C15.7092 5.21484 20.0353 8.79506 20.0353 11.5006C20.0353 14.2061 15.7092 17.7863 10.9996 17.7863C6.28996 17.7863 1.96387 14.2061 1.96387 11.5006C1.96387 8.79506 6.28996 5.21484 10.9996 5.21484ZM10.9996 6.78627C7.09908 6.78627 3.5353 9.73561 3.5353 11.5006C3.5353 13.2655 7.09908 16.2148 10.9996 16.2148C14.9001 16.2148 18.4639 13.2655 18.4639 11.5006C18.4639 9.73561 14.9001 6.78627 10.9996 6.78627ZM10.9996 8.3577C12.7353 8.3577 14.1424 9.76481 14.1424 11.5006C14.1424 13.2363 12.7353 14.6434 10.9996 14.6434C9.26383 14.6434 7.85672 13.2363 7.85672 11.5006C7.85672 9.76481 9.26383 8.3577 10.9996 8.3577ZM10.9996 9.92913C10.1317 9.92913 9.42815 10.6327 9.42815 11.5006C9.42815 12.3684 10.1317 13.072 10.9996 13.072C11.8675 13.072 12.571 12.3684 12.571 11.5006C12.571 10.6327 11.8675 9.92913 10.9996 9.92913Z" fill="#CAD4DD" />
                        </svg>
                    )}
                </div>
                {(errorPsw1 && !errorPsw2) && (
                    <div className="error-text">
                        {msgPsw1}
                    </div>
                )}
            </div>
            <div className={`input ${errorPsw2 ? 'error' : ''}`} style={{ marginTop: "10rem" }}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0003 1.92773C12.3672 1.92773 14.286 3.84651 14.286 6.21345L14.2875 7.65826C14.8895 7.69557 15.2735 7.80091 15.6695 8.01265C16.1432 8.26598 16.5192 8.642 16.7725 9.11569C17.0477 9.63017 17.1431 10.1246 17.1431 11.1033V15.6093C17.1431 16.588 17.0477 17.0824 16.7725 17.5969C16.5192 18.0706 16.1432 18.4466 15.6695 18.7C15.155 18.9751 14.6605 19.0706 13.6818 19.0706H6.31873C5.34002 19.0706 4.84558 18.9751 4.33109 18.7C3.8574 18.4466 3.48138 18.0706 3.22805 17.5969C2.9529 17.0824 2.85742 16.588 2.85742 15.6093V11.1033C2.85742 10.1246 2.9529 9.63017 3.22805 9.11569C3.48138 8.642 3.8574 8.26598 4.33109 8.01265C4.72717 7.80082 5.11138 7.69548 5.71381 7.65822L5.71456 6.21345C5.71456 3.84651 7.63334 1.92773 10.0003 1.92773ZM13.6818 9.07059H6.31873C5.55568 9.07059 5.28404 9.12305 5.0048 9.27239C4.78007 9.39257 4.60797 9.56467 4.48779 9.7894C4.33845 10.0686 4.28599 10.3403 4.28599 11.1033V15.6093C4.28599 16.3723 4.33845 16.644 4.48779 16.9232C4.60797 17.1479 4.78007 17.32 5.0048 17.4402C5.28404 17.5896 5.55568 17.642 6.31873 17.642H13.6818C14.4449 17.642 14.7165 17.5896 14.9958 17.4402C15.2205 17.32 15.3926 17.1479 15.5128 16.9232C15.6621 16.644 15.7146 16.3723 15.7146 15.6093V11.1033C15.7146 10.3403 15.6621 10.0686 15.5128 9.7894C15.3926 9.56467 15.2205 9.39257 14.9958 9.27239C14.7165 9.12305 14.4449 9.07059 13.6818 9.07059ZM10.0003 11.2134C10.3948 11.2134 10.7146 11.5332 10.7146 11.9277V14.0706C10.7146 14.4651 10.3948 14.7849 10.0003 14.7849C9.60579 14.7849 9.28599 14.4651 9.28599 14.0706V11.9277C9.28599 11.5332 9.60579 11.2134 10.0003 11.2134ZM10.0003 3.35631C8.42232 3.35631 7.14314 4.63549 7.14314 6.21345V7.64202H12.8574V6.21345C12.8574 4.63549 11.5782 3.35631 10.0003 3.35631Z" fill="#CAD4DD" />
                </svg>
                <input type={showPassword ? 'text' : 'password'}
                    value={inputPassword2}
                    onChange={(e) => { handlePassword2Change(e); setError(false); setErrorPsw1(false); setErrorPsw2(false); }} placeholder='Confirm new password'
                    style={{ paddingLeft: "46rem", paddingRight: "46rem" }}

                />
                <div className="show" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.05517 4.26529L10.2391 8.44922L10.2417 8.44856L14.0505 12.2573L14.0498 12.2599L18.6266 16.8367C18.9334 17.1436 18.9334 17.641 18.6266 17.9479C18.3198 18.2547 17.8223 18.2547 17.5154 17.9479L16.042 16.4758C14.5201 17.3133 12.7915 17.7852 10.9996 17.7852C6.42811 17.7852 1.96387 14.3626 1.96387 11.4994C1.96387 9.82823 3.68082 7.7521 6.04421 6.47673L4.944 5.37645C4.63716 5.06961 4.63716 4.57213 4.944 4.26529C5.25084 3.95845 5.74832 3.95845 6.05517 4.26529ZM3.5353 11.4994C3.5353 13.3899 7.21857 16.2137 10.9996 16.2137C12.3608 16.2137 13.683 15.8912 14.8763 15.3105L13.2554 13.6878C12.6842 14.2765 11.8846 14.6423 10.9996 14.6423C9.26383 14.6423 7.85672 13.2352 7.85672 11.4994C7.85672 10.6144 8.22254 9.81484 8.8112 9.24366L7.21234 7.64607C5.09127 8.65283 3.5353 10.4261 3.5353 11.4994ZM10.9996 5.21373C15.5711 5.21373 20.0353 8.63631 20.0353 11.4994C20.0353 12.2417 19.6949 13.0695 19.0951 13.8828C18.8375 14.232 18.3456 14.3063 17.9964 14.0488C17.6471 13.7912 17.5728 13.2993 17.8304 12.9501C18.248 12.3839 18.4639 11.8588 18.4639 11.4994C18.4639 9.609 14.7806 6.78516 10.9996 6.78516C10.5656 6.78516 10.2139 6.43338 10.2139 5.99944C10.2139 5.5655 10.5656 5.21373 10.9996 5.21373ZM9.92262 10.3551C9.61821 10.6417 9.42815 11.0484 9.42815 11.4994C9.42815 12.3673 10.1317 13.0709 10.9996 13.0709C11.4507 13.0709 11.8574 12.8808 12.1439 12.5764L9.92262 10.3551Z" fill="black" />
                        </svg>

                    ) : (
                        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.9996 5.21484C15.7092 5.21484 20.0353 8.79506 20.0353 11.5006C20.0353 14.2061 15.7092 17.7863 10.9996 17.7863C6.28996 17.7863 1.96387 14.2061 1.96387 11.5006C1.96387 8.79506 6.28996 5.21484 10.9996 5.21484ZM10.9996 6.78627C7.09908 6.78627 3.5353 9.73561 3.5353 11.5006C3.5353 13.2655 7.09908 16.2148 10.9996 16.2148C14.9001 16.2148 18.4639 13.2655 18.4639 11.5006C18.4639 9.73561 14.9001 6.78627 10.9996 6.78627ZM10.9996 8.3577C12.7353 8.3577 14.1424 9.76481 14.1424 11.5006C14.1424 13.2363 12.7353 14.6434 10.9996 14.6434C9.26383 14.6434 7.85672 13.2363 7.85672 11.5006C7.85672 9.76481 9.26383 8.3577 10.9996 8.3577ZM10.9996 9.92913C10.1317 9.92913 9.42815 10.6327 9.42815 11.5006C9.42815 12.3684 10.1317 13.072 10.9996 13.072C11.8675 13.072 12.571 12.3684 12.571 11.5006C12.571 10.6327 11.8675 9.92913 10.9996 9.92913Z" fill="#CAD4DD" />
                        </svg>
                    )}
                </div>
                {errorPsw2 && (
                    <div className="error-text">
                        {msgPsw2}
                    </div>
                )}
            </div>
        </div>
    )
}
